module.exports = __webpack_public_path__ + "img/company3.c52581ac.png";